import { useRef } from "react"
import DropdownTrigger from "./dropdown-trigger"
import useOutsideClick from "@/hooks/use-outside-click"
import { useOverlayStore } from "@/hooks/use-overlay-store"
import { langStore } from "@/stores/lang-store"
import { dropdownBundle } from "./dropdown-const"
import { RESOURCE_COLOR_MAP } from "@/constants/resource-const"

const DropdownDong = ({
  value,
  options = [],
  onChange,
  placeholder = "동 선택",
  unitStatusMap = {},
  currentResource = "water",
  optionClassName = "min-w-[calc(200%+8px)]"
}) => {
  const { lang } = langStore()
  const wrapperRef = useRef(null)
  const { activeId, toggle, close } = useOverlayStore()
  const selected = options.find((option) => option.id === value)

  useOutsideClick({
    ref: wrapperRef,
    enabled: activeId === "dong",
    onOutside: () => close()
  })

  const handleSelect = (id) => {
    onChange?.(id)
    close()
  }

  return (
    <div ref={wrapperRef} className="relative">
      <DropdownTrigger
        label={selected?.label}
        placeholder={placeholder}
        targetId={"dong"}
        onClick={() => toggle("dong")}
      />

      {activeId === "dong" && (
        <div
          className={`absolute left-0 z-30 mt-2 
            md:min-w-[320px] md:max-w-105 rounded-2xl 
            border border-gray-200 bg-white p-2 shadow-xl
            ${optionClassName} 
          `}
        >
          <div className="grid gap-1 max-h-100 overflow-y-auto pr-1">
            {options.map((opt) => {
              const active = value === opt.id
              const badges = unitStatusMap?.[opt.id]?.dongBadges || {}

              return (
                <button
                  key={opt.id}
                  type="button"
                  onClick={() => handleSelect(opt.id)}
                  className={`
                    rounded-lg px-3 py-2.5
                    flex items-center justify-between gap-3
                    text-left text-sm font-medium
                    transition-all duration-150 cursor-pointer
                    ${
                      active
                        ? "bg-indigo-500 text-white shadow-sm"
                        : "text-gray-700 hover:bg-indigo-50 hover:text-indigo-700"
                    }
                  `}
                >
                  <span>{opt.label}</span>

                  <div className="flex items-center gap-1.5 shrink-0">
                    {Object.entries(badges).map(([key, count]) => {
                      if (!count) return null

                      if (currentResource === "water") {
                        if (key !== "leak" && key !== "water") return null
                      } else {
                        if (key !== currentResource) return null
                      }
                      // 상태 텍스트 가로채기 (기본값은 key)
                      const badgeLabel =
                        key === "leak" ? dropdownBundle.leak[lang] : dropdownBundle.overuse[lang]

                      const badgeColor = RESOURCE_COLOR_MAP[key] || "#9ca3af"

                      return (
                        <div
                          key={key}
                          className="px-2 py-0.5 rounded-md text-[11px] font-bold tracking-wide shadow-sm"
                          style={{
                            backgroundColor: active
                              ? "rgba(255, 255, 255, 0.25)"
                              : `${badgeColor}18`,
                            color: active ? "#ffffff" : badgeColor,
                            border: active
                              ? "1px solid rgba(255, 255, 255, 0.4)"
                              : `1px solid ${badgeColor}40`
                          }}
                        >
                          {badgeLabel} {count}
                        </div>
                      )
                    })}
                  </div>
                </button>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default DropdownDong
